class ValidatePage {
    constructor() {
        this.page = am.$('#am-maincontent'); // validation container but this.update_page_to_section() can be used to validate smaller sections. 
        this.local_validations = [];
        this.omit_by_section = { 
            set: false,
            section: '',
            list: []
        }
        this.inputs = [];
        this.has_teathered_inputs = false;
        this.address_list = [];
        this.phone_list = [];
        this.website_list = [];
        this.failed_list = [];
        this.adminOverride = false;

        this.debug = {
            // inputs_list: true, // view all inputs being validated 
            failed_list: true, // view all failed validation - Leave on for easy instance debugging 
            // confirm_page: true, // final validation return T/F
            // this: true, // Look at individual elements 
            extends : { // turn on debuging in extended validation Classes
                // AddressDefaultTypeValidation: true,
                // AddressValidation: true,
                // EmailValidation: true,
                // PasswordValidation: true,
                // PhoneNumberValidation: true,
                // UsernameValidation: true,
                // PaymentMethodValidation: true,
                // WebsiteUrlValidation: true
                TimeTrackingValidation: true
            }
        }
    }

    update_page_to_section(section){ 
        this.page = section;
    }

    add_local_validation(validation){
        this.local_validations.push(validation);
    }

    admin_override(){   
        this.adminOverride = true;
    }

    set_omit_section(section){
        this.omit_by_section.set = true;
        this.omit_by_section.section = section;
    }

    get_page_inputs(omit = ''){
        if(omit != '')
            omit = escape_brackets(omit);

        var search_str = 'input:visible, select:visible, textarea:visible';
        if(this.has_teathered_inputs)
            search_str= 'input:visible, select:visible, textarea:visible, input.js-required_from_tether, select.js-required_from_tether, textarea.js-required_from_tether';
        
        var inputs = this.page.find(search_str).not( omit ); 
        
        inputs.each((i, el) => {
            this.inputs.push(am.$(el));
        })

        return this.inputs;
    }

    async validate(omit = '', include = '', tethered_inputs=false){ 
        console.log('ValidatePage');
        // Notes: 
            // OMIT: takes an string to skip over any designated inputs. (Speed up processes by not including $elms not needing to be validated on the page
            // INCLUDE: All input types should be automatically included in the generic find but just in case there is an issue or a requirement to validate a non input.

        show_loading_svg();

        if(tethered_inputs){
            this.has_teathered_inputs = true
            process_tethered(tethered_inputs); // assigns js-required && js-required_from_tether class based on tethered inputs having a value making other inputs requiredv
        }

        if(this.omit_by_section.set){ // Needs to be set before ValidatePage.validate();
            this.set_omit_list_by_section(); 

            if(omit != '' && this.omit_by_section.set)
                omit = omit.concat(', ' + this.omit_by_section.list);
            else
                omit = this.omit_by_section.list;
        }

        this.inputs = this.get_page_inputs(omit);

        if(include){ 
            include.each((di) => {
                this.inputs.push(am.$(di));
            })
        }
        
        if(this.debug && this.debug.inputs_list)
            console.log(this.inputs, "this.inputs")
        
        var vpi = await this.validate_page_inputs();
        return vpi;
    }

    confirm_page(){
        if(this.failed_list.length > 0)
            return false;
        else
            return true;
    }

    async validate_page_inputs(){
        const lastIndex = this.inputs.length - 1;
        if(this.adminOverride) this.inputs = []; // drops all inputs from this.inputs to trick ValidatePage that all inputs have valid values
        await Promise.all(
            this.inputs.map(async (el, i) => {
                var $this = am.$(el);
                if (!$this.hasClass('js-required') && String($this.val() || '').trim() === '') return; // DEV-13247: an optional input left blank has nothing to validate
                if(this.debug.this)
                    console.log($this, "this")

                // ----------------------- Generic Fields Start --------------------------------------------
                if($this.hasClass('js-required'))
                    this.validate_required($this);
                    
                if($this.hasClass('js-no-special-characters'))
                    this.validate_special_chars($this);
                if($this.hasClass('js-minLength'))
                    this.validate_min_length($this);
                if($this.hasClass('js-maxLength'))
                    this.validate_max_length($this);
                if($this.hasClass('js-number'))
                    this.validate_number($this);
                if($this.hasClass('js-number-positive'))
                    this.validate_number($this, true);
                if($this.hasClass('js-not-negative'))
                    this.not_negative($this);
                if($this.hasClass('js-required-checked'))
                    this.validate_checked($this);
                if($this.hasClass('js-select-process'))
                    this.validate_process_selected($this);
                if($this.hasClass('js-contact-id'))
                    this.validate_contact_id($this);
                if($this.hasClass('js-order-number'))
                    this.validate_order_number($this);
                if($this.hasClass('js-order-status'))
                    this.validate_order_status($this);
                if($this.hasClass('js-validate-HH-MM'))
                    this.validate_hour_min_format($this);
                if($this.hasClass('js-json-only'))
                    this.validate_json_only($this);
                if($this.hasClass('js-html-only'))
                    this.validate_html_only($this);

                // ----------------------- Generic Fields End --------------------------------------------
                // ----------------------- Username / Email Start ----------------------------

                if($this.hasClass('js-username'))
                    await this.process_username($this);
                if($this.hasClass('js-email'))
                    await this.process_email($this);

                //----------------------- Username / Email End -------------------------------

                // ------------ Dynamic linked inputs Ex. Password, Phone, Website, Address --- Start --------
                if($this.hasClass('js-phone-number') || $this.hasClass('js-phone-type') || $this.hasClass('js-phone-extension'))
                    await this.process_phone($this);
                if($this.hasClass('js-website-url') || $this.hasClass('js-website-type'))
                    this.process_website($this);
                // if($this.hasClass('js-address-name') || $this.hasClass('js-address-type') || $this.hasClass('js-address') || $this.hasClass('js-address2') || $this.hasClass('js-address3') || $this.hasClass('js-address-city') || $this.hasClass('js-address-country') || $this.hasClass('js-address-state') || $this.hasClass('js-adress-zip') )
                if($this.hasClass('js-address') )
                    await this.process_address($this);
                if($this.hasClass('js-validate-cc-number'))
                    await this.process_card_payment($this);
                if($this.hasClass('js-password') || $this.hasClass('js-confirm-password'))
                    this.process_password($this);
                // ------------ Dynamic linked inputs Ex. Passsword, Phone, Website, Address --- End --------

                // ------------------------------ Default Address Type Start --------------------------
                if($this.hasClass('js-default-address'))
                    this.process_default_address_type($this);
                // ------------------------------ Default Address Type End ---------------------------

                if(i === lastIndex)
                    await this.process_local_validations();
            })
        );

        try{
            if(this.confirm_page()){
                if(this.debug && this.debug.confirm_page){
                    var debug = {
                        this: this,
                        page_section: { section: this.page, },
                        target_inputs: { targets: deconstruct_dom_obj(this.inputs), length: this.inputs.length, },
                        failed_list: { list: this.failed_list, length: this.failed_list.length, },
                    }
                    console.log( debug, "debug" )
                }
    
                hide_loading_svg();
                return true;
            }else{
                if(this.return_failed_list){
                    hide_loading_svg();
                    return this.failed_list;
                }
                else {
                    this.iteriate_errors();
                    return false;
                }
            }
        }catch(e){
            console.log(e);
        }
    }

    failed_obj_push(obj){
        const exists = this.failed_list.some(fail_obj => clean_id(fail_obj.target) === clean_id(obj.target) );

        if (!exists) {
            obj.target = '#'+obj.target; // ensure format is correct for display_error_msg();
            this.failed_list.push( obj );
        }
    }

    async process_local_validations(){
        if(this.failed_list.length == 0 && this.local_validations.length > 0){
            await Promise.all(
                this.local_validations.each( async (func) => {
                    await func(this);
                })
            );
        }else{
            return;
        }
    }

    validate_required($this){
        if($this.val() == '' && !$this.hasClass('js-allowed-none')) {
            this.failed_obj_push( { target: $this.attr('id'), msg: get_language_translation('LANG_THIS_IS_A_REQ_FIELD')})
        }
    }

    validate_checked($this){
        if(!$this.prop('checked')) {
            this.failed_obj_push( { target: $this.attr('id'), msg: get_language_translation('LANG_THIS_IS_A_REQ_FIELD')} );
        }
    }

    validate_process_selected($this){
        let undefined_arr = [undefined, null, ""];
        if (undefined_arr.includes($this.val())) 
            this.failed_obj_push( { target: $this.attr('id'), custom_section: $this.attr('id'), msg: get_language_translation('LANG_CHOOSE_A_PROCESS')} );
    }

    validate_contact_id($this){
        if($this.attr('id') == 'contact_id' && $this.val() === ''){
            this.failed_obj_push( { target: 'employee', msg: get_language_translation('LANG_OPT_SEL_AN_EMPLOYEE')} );
        }
        if($this.attr('id') == 'employee' && $this.val() === ''){ // Both contact_id and employee are required since contact_id is hidden
            this.failed_obj_push( { target: $this.attr('id'), msg: get_language_translation('LANG_OPT_SEL_AN_EMPLOYEE')} );
        }
    }

    validate_order_number($this){
        if($this.attr('id') == 'track_order_id' && $this.val() === ''){
            this.failed_obj_push( { target: 'track_order', custom_section: 'track_order', msg: get_language_translation('LANG_INVALID_ORDER_NUMBER').capitalize()} );
        }
    }

    validate_order_status($this){
        if($this.val() === ''){
            this.failed_obj_push( { target: 'track_order', custom_section: 'track_order', msg: get_language_translation('LANG_INVALID_ORDER_NUMBER').capitalize()} );
        }
    }

    validate_hour_min_format($this){
        const timeRegex = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
        if(!timeRegex.test($this.val()))
            this.failed_obj_push( { target: $this.attr('id'), msg: get_language_translation('LANG_HHMM_FORMAT')} );
    }

    validate_json_only($this){ // This function is based off JSON.parse(val) so it should be used with " not ' for the json str
        let val = $this.val();
        if(val == '') {
            return;
        }
        else if(!val.includes('{', '}')){
            this.failed_obj_push( { target: $this.attr('id'), msg: get_language_translation('TT_MSG_TEXTAREA_REQUIRES_VALID_JSON_FORMATTING')} );
        }
        else{
            try {
                const disallowed = ["'", '"'];
                const firstChar = val.charAt(0);
                const lastChar = val.charAt(val.length - 1);
    
                if(firstChar === '"')
                    this.failed_obj_push( { target: $this.attr('id'), msg: "Please remove \" from start of string"} );
                else if(lastChar === '"')
                    this.failed_obj_push( { target: $this.attr('id'), msg: "Please remove \" from end of string"} );
                else if(firstChar === "'")
                    this.failed_obj_push( { target: $this.attr('id'), msg: "Please remove ' from start of string"} );
                else if(lastChar === "'")
                    this.failed_obj_push( { target: $this.attr('id'), msg: "Please remove ' from end of string"} );
    
                if(disallowed.includes(firstChar) || disallowed.includes(lastChar)) 
                    return
                else
                    JSON.parse(val);
            } catch (e) {
                if(val.includes("'"))
                    this.failed_obj_push( { target: $this.attr('id'), msg: "Please use \" instead of '"} );
                else
                    this.failed_obj_push( { target: $this.attr('id'), msg: get_language_translation('TT_MSG_TEXTAREA_REQUIRES_VALID_JSON_FORMATTING')} );
    
            }
        }
    }

    validate_html_only($this) {
        const val = $this.val();
        const validated_json = simpleValidateHtmlStr(val, true);

        if (!validated_json.valid){
            if(isDebugMode()){
                var error_location = locateHtmlValidationError(val);
                console.log("Error Location data", {pattern: error_location.pattern, index: error_location.index, match: error_location.match, context: error_location.context})
            }

            this.failed_obj_push({ 
                target: $this.attr('data-target_id'), 
                msg: validated_json.type.capitalize() + ': ' + validated_json.error,
                custom_section: $this.attr('data-target_id')
            });
        }
    }

    validate_special_chars($this){
        if(test_reqex($this.val(), /[^a-zA-Z0-9.]/)) {
            this.failed_obj_push( { target: $this.attr('id'), msg: get_language_translation('SPECIAL_CHARACTERS_ARE_NOT_ALLOWED_LANG')} );
        }
    }

    validate_min_length($this){
        if($this.val().length < $this.attr('minlength')){
            if($this.attr('minlength') > 1) {
                var msg = get_language_translation('MINIMUM_REQUIRED_LENGTH_OF_LANG') + ' ' + $this.attr('minlength')
            }
            else {
                var msg = get_language_translation('LANG_ERR_ONE_CHAR_REQUIRED')
            }

            this.failed_obj_push( { target: $this.attr('id'), msg: msg } );
        }
    }

    validate_max_length($this){
        if($this.val().length > $this.attr('maxlength')){
            if($this.attr('minlength') > 1) {
                var msg = get_language_translation('LANG_LABEL_MAX_LENGTH') + ' - ' + $this.attr('maxlength')
            }

            this.failed_obj_push( { target: $this.attr('id'), msg: msg } );
        }
    }

    validate_number($this, pos_val = false){
        var check = false;
        var decimal = parseInt($this.attr('data-decimal')) > 0 ? true : false;

        if(decimal)
            var round = decimal_check($this.val(), $this.attr('data-decimal'));
        else
            var round = decimal_check($this.val());
        
        if(pos_val) {
            var numValue = parseFloat(round);
            check = isNumber(numValue) && numValue >= 0;
        } else {
            check = isNumber(parseInt(round));
        }

        if(!check) {
            this.failed_obj_push( { target: $this.attr('id'), msg: get_language_translation('LANG_ERR_MONTHLY_COST_REQ_POS_VALUE') } );
        }
    }

    not_negative($this){
        var check = false;
        if($this.val() > 0)
            check = true;

        if(!check) {
            this.failed_obj_push( { target: $this.attr('id'), msg: get_language_translation('LANG_MSG_NEGATIVE_VALUE_NOT_ALLOWED')} );
        }
    }

    set_omit_list_by_section(){
        var omit_list = [];
        var inputs = this.omit_by_section.section.find('input, select, textarea'); 

        inputs.each((i, inp) => {
            omit_list.push('#'+inp.id)
        })

        this.omit_by_section.list = omit_list.toString().replace(',', ', ');
    }

    process_invalid(obj){
        if(obj.all){
            obj.all.each((el) => {
                this.failed_obj_push( { target: el.elm.attr('id'), msg: el.msg } );
            })
        }else{
            this.failed_obj_push( { target: obj.elm.attr('id'), msg: obj.msg } );
        }
    }

    async process_username($this){
        try{
            var username = new ValidateUsername(this);
            await username._validate($this);
    
            if(this.debug && this.debug.extends.UsernameValidation)
                console.log(username, "username")
        }catch(e){
            console.log(e);
        }
    }

    async process_email($this){
        try{
            var email = new ValidateEmail(this);
            await email._validate($this);
    
            if(this.debug && this.debug.extends.EmailValidation)
                console.log(email, "email")
        }catch(e){
            console.log(e);
        }
    }

    async process_phone($this){
        try{
            var phone = new ValidatePhoneNumber(this);
                await phone._validate($this);
            
            if(this.debug && this.debug.extends.EmailValidation)
                console.log(phone, "phone");
        }catch(e){
            console.log(e);
        }
    }

    process_website($this){
        try{
            var website = new ValidateWebsiteUrl(this);
                var valid_website = website._validate($this);
            
            if(!valid_website.passed)
                this.process_invalid_website(valid_website);
        }catch(e){
            console.log(e);
        }
    }

    async process_address($this){
        try{
            var address = new ValidateAddress(this);
                await address._validate($this);

            if(this.debug && this.debug.extends.AddressValidation)
                console.log(address, "address")
        }catch(e){
            console.log(e)
        }
    }

    async process_card_payment($this){
        try{
            var card_payment = new ValidatePaymentMethod(this);
                await card_payment._validate($this);

            if(this.debug && this.debug.extends.PaymentValidation)
                console.log(card_payment, "card_payment")
        }catch(e){
            console.log(e)
        }
    }

    async process_password($this){
        try{
            var password = new ValidatePassword(this);
                await password._validate($this);
            
            if(this.debug && this.debug.extends.PasswordValidation)
                console.log(password, "password")
        }catch(e){
            console.log(e);
        }
    }

    async process_default_address_type($this){
        try{
            var def_address = new ValidateAddressDefaultType(this);
                await def_address._validate($this);
            
            if (this.debug && this.debug.extends.AddressDefaultTypeValidation )
                console.log(def_address, "def_address")
        }catch(e){
            console.log(e);
        }
    }

    // NOTE: purposley did not combine 
    // process_invalid_website 
    // to avoid bugs with future updates / iteations if the object chnages. 
    process_invalid_website(obj){ this.process_invalid(obj); };

    iteriate_errors(){
        if(this.debug && this.debug.failed_list){
            this.failed_list.each((obj, i) => { 
                console.log(obj, "obj")
                obj.elm = am.$( escape_brackets(obj.target) ); 
            });
            console.log(this.failed_list, "this.failed_list");
        }

        this.failed_list.each( (obj, i) => {
            const target = escape_brackets(obj.target);

            if(am.$(target).parent().prop('tagName') == 'TD')
                display_error_msg_datatable_row({
                    target: target, 
                    msg: obj.msg, 
                    custom_section: obj.custom_section ? obj.custom_section : false, 
                    set_focus: i == 0 ? true : false
                })
            else if(target == '#tc_checkbox'){
                const $cb = am.$(target);
                $cb.addClass('am-checkbox--del-appearance');
            }
            else if(target == '#password'){
                const $password = am.$(target);
                const $criteria_wrapper = am.$('#am-password-criteria-wrapper');
                var $label = $criteria_wrapper.children('label.js-not-matched');
                if($password.val() == ''){
                    display_error_msg({
                        target: target, 
                        msg: obj.msg, 
                        custom_section: obj.custom_section ? obj.custom_section : false, 
                        set_focus: i == 0 ? true : false,
                        err: { border: true, text: true, hide_msg: true }
                    });
                    var labels = $criteria_wrapper.children('label');
                    labels.each((i, el) => { 
                        am.$(el).addClass('invalid'); 
                    })
                }

                if($password.val() === am.$('#conf-password').val()){
                    $label.addClass('hide');
                    if(am.$('#am-password-criteria-wrapper').is(':hidden')){
                        $criteria_wrapper.removeClass('hide');
                        if(i == 0)
                            am.$(target).focus();
                    }
                }
                else{
                    $label.removeClass('hide');
                }
            }
            else {
                display_error_msg({
                    target: target,
                    msg: obj.msg,
                    custom_section: obj.custom_section ? obj.custom_section : false,
                    set_focus: i == 0 ? true : false
                });
            }
        })

        hide_loading_svg();
    }

    define_elem($this){
        return {
            elm: $this, 
            id: $this.attr('id'), 
            classlist: $this.prop('className'), 
            value: $this.val() == null ? '' : $this.val()
        };
    }
}

function clean_id(id){
    return id.replace('#', '');
}

function escape_brackets(string){
    return string.replaceAll(/[\[\]]/g, '\\$&');
}

function remove_escape_brackets(string){
    return string.replaceAll(/\\\[/g, '[').replaceAll(/\\\]/g, ']');
}

function test_reqex(value, reg){
	if(reg.test(value))
		return true;
	else 
		return false;
}

function get_dynamic_teather(sectionClass){
    var sections = am.$('.'+sectionClass);
    var teather_array = [];
    sections.each((i, section) => {
        var inputs = am.$(section).find('input, select, textarea').not('[type="hidden"], .js-omit-teather')
        section_teather = [];

        inputs.each((i, input) => {
            const $input = am.$(input);
            if($input.attr('type') == 'radio'){
                if($input.val() == 1 && $input.prop('checked') == 1)
                    section_teather.push($input.attr('id'));
            }
            else{
                section_teather.push($input.attr('id'))
            }
        })

        teather_array.push(section_teather);
    })

    return teather_array;
}

function process_tethered(tethered_inputs){
    var contains_subarrays = false;
    if(typeof tethered_inputs[0] != 'string'){
        contains_subarrays = true;
    }

    if(contains_subarrays){
        tethered_inputs.each((group) => {
            var inputs_requiring_value = [];
            group.each((d) => {
                var $d = am.$('#' + d);
                if ($d.val() != '') {
                    group.each((d2) => inputs_requiring_value.push(am.$('#' + d2)));
                }
            });

            if(inputs_requiring_value.length > 1)
                assign_js_required_to_tethered_inputs(inputs_requiring_value)
        })
    }else{
        var inputs_requiring_value = [];
        tethered_inputs.each((d) => {
            var $d = am.$('#' + d);
            if($d.val() != ''){
                tethered_inputs.each((d2) => { 
                    inputs_requiring_value.push( am.$('#' + d2) )
                });
            }
        })

        if(inputs_requiring_value.length > 1)
            assign_js_required_to_tethered_inputs(inputs_requiring_value)
    }
}

function assign_js_required_to_tethered_inputs(inputs_requiring_value){
    inputs_requiring_value.each((el) => {
        if(am.$(el).val() == '')
            am.$(el).addClass('js-required js-required_from_tether');
    })
}

function isPositive(number) {
    return number > 0;
}

function isNumber(value) {
    return !isNaN(value);
}

function decimal_check(val, desiredDecimalPlaces = 2){
    const limitedNumber = Number(val).toFixed(desiredDecimalPlaces);
    return limitedNumber;
}

function clear_validation_errs() { // Clear all validation errors
    am.$('.error-msg').remove(); // Remove error message elements completely
    am.$('.am-error-text, .am-error-border').removeClass('am-error-text am-error-border'); // Remove error classes from elements
}

// Debugging --------
function deconstruct_dom_obj(arr){
    var new_arr = arr.map((el, i) => {
        if(el[0]){
            var el_obj = {};
            var elm = el[0];

            el_obj.elem = elm;
            el_obj.id = elm.id;
            el_obj.classList = elm.classList.toString();
            // add whatever else is useful
        }

        return el_obj;
    });

    return new_arr;
}
